//动物类型
export const animalTypeList = [
  {animalTypeId:1,animalTypeName:'肉牛',VarietyDepotCode:'Bovini',LabelCode:'Positive',stageList:[
      {stageId:1,stageName:'犊牛'},
      {stageId:2,stageName:'育成期'},
      {stageId:3,stageName:'育肥前期'},
      {stageId:4,stageName:'育肥后期'}
    ]
  },
  {animalTypeId:2,animalTypeName:'奶牛',VarietyDepotCode:'Bovini',LabelCode:'PositiveDairy',stageList:[
    {stageId:1,stageName:'犊牛'},
  ]},
  {animalTypeId:3,animalTypeName:'肉羊-绵羊',VarietyDepotCode:'Sheep',stageList:[
    {stageId:1,stageName:'羔羊'},
    {stageId:2,stageName:'育成期'},
    {stageId:3,stageName:'育肥前期'},
    {stageId:4,stageName:'育肥后期'}
  ]},
  {animalTypeId:4,animalTypeName:'肉羊-山羊',VarietyDepotCode:'Goat',stageList:[
    {stageId:1,stageName:'羔羊'},
    {stageId:2,stageName:'育成期'},
    {stageId:3,stageName:'育肥前期'},
    {stageId:4,stageName:'育肥后期'}
  ]}
]
//性别
export const sexList = [
  {sexId:1,sexName:'公'},
  {sexId:2,sexName:'母'},
  {sexId:3,sexName:'混养'}
]
//饲养模式
export const feedingPatternList = [
  {feedingPatternId:1,feedingPatternName:'散养'},
  {feedingPatternId:2,feedingPatternName:'栓系'}
]
//产品定位
export const productPositionList = [
  {productPositionId:1,productPositionName:'高档'},
  {productPositionId:2,productPositionName:'中档'},
  {productPositionId:3,productPositionName:'低档'},
]
